import { render, staticRenderFns } from "./VertragAusRuheModal.vue?vue&type=template&id=10878d85&"
import script from "./VertragAusRuheModal.vue?vue&type=script&lang=js&"
export * from "./VertragAusRuheModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports